import { SVGProps } from "react";

export default function EyeIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M12.9823 10C12.9823 11.65 11.649 12.9833 9.99896 12.9833C8.34896 12.9833 7.01562 11.65 7.01562 10C7.01562 8.35 8.34896 7.01667 9.99896 7.01667C11.649 7.01667 12.9823 8.35 12.9823 10Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99792 16.8914C12.9396 16.8914 15.6813 15.1581 17.5896 12.1581C18.3396 10.9831 18.3396 9.0081 17.5896 7.8331C15.6813 4.8331 12.9396 3.09977 9.99792 3.09977C7.05625 3.09977 4.31458 4.8331 2.40625 7.8331C1.65625 9.0081 1.65625 10.9831 2.40625 12.1581C4.31458 15.1581 7.05625 16.8914 9.99792 16.8914Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
